<template>
    <div class="col s12 l4">
        <h2 class="indigo-text text-darken-4">What We Do...</h2>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus ad saepe eaque excepturi? Doloremque rerum unde nemo eos veritatis ex. Aspernatur delectus dolorum praesentium neque exercitationem quidem nemo laborum a?</p>
        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus ad saepe eaque excepturi? Doloremque rerum unde nemo eos veritatis ex. Aspernatur delectus dolorum praesentium neque exercitationem quidem nemo laborum a?</p>
    </div>
</template>

<script>
export default { }
</script>